<template>
  <div class="ma-4 px-4">
    <v-sheet outlined>
      <v-data-table
        :headers="streamHeaders"
        :search="search"
        :items="streams"
        :custom-filter="customFilter"
        :single-expand="true"
        item-key="name"
        hide-default-footer
        fixed-header
        class="secondary row-height-50"
      >
        <template #[`item.program_id`]="{ item }">
          {{ getProgram(item) }}
        </template>
        <template #[`item.active`]="{ value }">
          <v-chip small :color="value ? 'green' : 'red'" dark>
            {{ showActiveStatus(value) }}
          </v-chip>
        </template>
        <template #[`item.action`]="{ item }">
          <v-icon small class="mr-2" color="accent" @click="editStream(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-sheet>
    <div class="pt-6">
      <span class="text-5xl font-weight-bold accent--text">
        STREAM SCHEMES</span
      >
    </div>
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      class="mt-2"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="stream_schemes"
            :custom-filter="customFilter"
            fixed-header
            :items-per-page="5"
            hide-default-footer
            class="secondary row-height-50"
          >
            <template #[`item.program_id`]="{ item }">
              {{ getProgram(item) }}
            </template>
            <template #[`item.program_scheme_id`]="{ item }">
              {{ getProgramScheme(item) }}
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-if="stream_schemes.length > 5" v-slot:footer>
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigateSchemes()"
                  style="cursor: pointer; color: #4f4584"
                  class="custom-hover"
                >
                  View More
                  <v-icon class="hover:accent text-sm ml-1 -mt-1"
                    >mdi-chevron-right</v-icon
                  >
                </span>
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createStreamScheme"
        @update="updateStreamScheme"
        :stream_scheme="stream_scheme"
        :programs="programs"
        :program_schemes="program_schemes"
        :program_id="Number(program_id)"
        :stream_id="Number(stream_id)"
        :streams="streams"
        :edit="editMode"
      />
    </v-dialog>
    <v-dialog v-model="streamDialog" width="800" persistent scrollable>
      <streamDialog
        v-if="streamDialog"
        @closeDialog="streamDialog = false"
        @update="updateStream"
        :stream="stream"
        :programs="programs"
        :edit="streamEditMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/scheme/stream_scheme.vue";
import streamDialog from "@/components/stream/form.vue";
import searchBar from "@/components/searchBar.vue";
import { streamSchemeHeaders, streamHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
    streamDialog,
  },
  data() {
    return {
      headers: streamSchemeHeaders,
      streamHeaders: streamHeaders,
      dialog: false,
      editMode: false,
      streamEditMode: false,
      streamDialog: false,
      search: "",
      stream: {},
      stream_scheme: {},
      streams: [],
      stream_schemes: [],
      program_schemes: [],
      programs: [],
      program_id: null,
      stream_id: null,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getQueryParams();
    this.discardHeadersTitle();
    this.$store.commit("setBreadcrumbs", [
      { text: "Streams", to: { name: "Streams" } },
      { text: this.stream_name },
    ]);
    this.initialise();
  },
  methods: {
    getQueryParams() {
      if (this.$route.query.id) {
        this.stream_id = this.$route.query.id;
        this.stream_name = this.$route.query.name;
        this.program_id = this.$route.query.program_id;
      }
    },
    discardHeadersTitle() {
      this.headers = this.headers.filter((h) => h.value != "program_id");
    },
    async initialise() {
      const [stream_schemes, streams, program_schemes, programs] =
        await Promise.all([
          this.$axios.get("stream_schemes"),
          this.$axios.get("streams"),
          this.$axios.get("program_schemes"),
          this.$axios.get("programs"),
        ]);
      const stream_data = streams.data.data;
      this.streams = stream_data.filter((s) => s.id == this.stream_id);
      const stream_list = stream_schemes.data.data;
      this.stream_schemes = stream_list.filter(
        (s) => s.stream_id == this.stream_id
      );

      this.program_schemes = program_schemes.data.data;
      this.programs = programs.data.data;
    },
    async createStreamScheme(data) {
      await this.$axios
        .post("stream_schemes", {
          stream_scheme: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream Scheme created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateStreamScheme(data) {
      await this.$axios
        .put("stream_schemes/" + data.id, {
          stream_scheme: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream Scheme updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateStream(data) {
      await this.$axios
        .put("streams/" + data.id, { stream: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream updated successfully",
            color: "success",
          });
          this.resetStreamValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    editStream(item) {
      this.stream = { ...item };
      this.streamEditMode = true;
      this.streamDialog = true;
    },
    resetStreamValues() {
      this.streamEditMode = false;
      this.streamDialog = false;
      this.stream = {};
    },
    edit(item) {
      this.stream_scheme = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.stream_scheme = {};
    },

    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    getProgram(item) {
      const program = this.programs.find((x) => x.id == item.program_id);
      return program?.degree?.short_name + " " + program?.specialization;
    },
    getProgramScheme(item) {
      const program_scheme = this.program_schemes.find(
        (p) => p.id === item.program_scheme_id
      );
      return program_scheme.name;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const program_scheme = this.getProgramScheme(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        program_scheme.toLowerCase().includes(search.toLowerCase())
      );
    },
    navigateSchemes() {
      this.$router.push({
        name: "Stream Schemes",
        query: {
          id: this.stream_id,
          name: this.stream_name,
          program_id: this.program_id,
        },
      });
    },
  },
};
</script>

<style></style>
